import type { VThemeConfig } from '../VThemeProvider';
import { joinCn } from '../util';
import createTwStyle from '../util/createTwStyle';
import { TABLE_ROW_SIZE } from './constant';
import type { VBaseTableProps } from './type';

type VBaseTableStyleProps = Partial<VBaseTableProps<any>> & {
  visibleShadow?: boolean;
  themeName?: VThemeConfig['name'];
};

const twStyle = createTwStyle<VBaseTableStyleProps>();

export default twStyle({
  vBaseTable: () => [
    joinCn('relative', 'w-full', 'overflow-x-auto overflow-y-hidden'),
  ],
  vBaseTableColumn: () => [
    joinCn('px-2', 'whitespace-nowrap', 'overflow-hidden', 'text-ellipsis'),
  ],
  vBaseTableColumnRow: () => [joinCn('bg-white', 'border-b')],
  vBaseTableTheadTr: ({ visibleShadow }) => [
    joinCn(
      'relative',
      'w-fit min-w-full',
      'border-gray-300',
      'bg-white',
      'border-b',

      visibleShadow && [
        'after:absolute after:bottom-[1px] after:left-0',
        'after:h-[1px] after:w-full',
        'after:shadow-lg',
        'after:content-[""]',
        'after:z-10',
      ],
    ),
  ],
  vBaseTableTbodyTr: () => [
    joinCn(
      'relative',
      'border-gray-200',
      'bg-white',
      'border-b',
      'aria-selected:bg-tertiary-200',

      'after:absolute after:top-0 after:left-0',
      'after:h-full after:w-full',
      'after:shadow-sm',
      'after:z-10',
      'after:content-none',
      'hover:after:content-[""]',
    ),
  ],
  vBaseTableTh: ({ rowSize }) => [
    joinCn(
      'py-[7px]',
      'text-gray-500',
      'px-2',
      'whitespace-nowrap',
      'overflow-hidden',
      'text-ellipsis',
      {
        'text-body-lg':
          rowSize === TABLE_ROW_SIZE.LG || rowSize === TABLE_ROW_SIZE.MD,
        'text-body-sm': rowSize === TABLE_ROW_SIZE.SM,
      },
    ),
  ],
  vBaseTableTd: ({ rowSize }) => [
    joinCn('relative', 'px-2 py-2.5', 'text-black', 'select-none', 'z-[11]', {
      'text-body-xl':
        rowSize === TABLE_ROW_SIZE.LG || rowSize === TABLE_ROW_SIZE.MD,
      'text-body-md': rowSize === TABLE_ROW_SIZE.SM,
    }),
  ],
  vBaseTableResizeHandle: () => [
    joinCn(
      'absolute',
      'top-1 bottom-1',
      'right-0',
      'w-[2px]',
      'cursor-col-resize',
      'hover:bg-primary-400/20',
      'active:bg-tetiary-300',
      'z-20',
    ),
  ],
});
